
import { Button, Carousel, CarouselItem } from "element-ui"

export default {
  name: "Banner",
  components: {
    [Button.name]: Button,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  methods: {
    handleJump() {
      location.href = window.testUrl || "https://baidu.com"
    },
    handleSwitch() {
      if (this.$i18n.locale === "en") {
        this.$i18n.locale = "zh"
      } else {
        this.$i18n.locale = "en"
      }
    }
  }
}
